// import { useState, useEffect } from 'react';
// import ModalDemo from './ModalDemo';
// import DemoEcommmerce from '../components/ecommerce/DemoEcommerce';
// import Karggu from '../svg/LogotipoKarggu_rojo.svg';
// import whatsapp from '../svg/wa.svg';

// export default function Footer() {

//   const [ecommerce, setEcommerce] = useState(false);

//   useEffect(() => {
//     if (window.location.href === 'https://karggu.com/ecommerce') {
//       setEcommerce(true);
//     }
//   }, []);


//   return(
//     <>
//       <div>
//         <a 
//           href="https://api.whatsapp.com/send?phone=2211203777&text=Hola%20Karggu,%20me%20gustaría%20simplificar%20los%20procesos%20de%20carta%20porte,%20operación%20y%20profesionalizar%20mi%20empresa%20de%20transporte."
//           target='_blank'
//           rel='noreferrer noopener'
//         >
//           <img src={whatsapp} alt="whatsapp" className='w-16 md:w-20 h-16 md:h-20 fixed bottom-5 right-5'/>
//         </a>
//       </div>
//       <div className="flex flex-col h-full md:mt-14">
//         <div className="flex flex-col p-8 md:flex-row justify-around h-5/6">
//           <a href="/" className='flex justify-start items-center'><img src={Karggu} alt="Karggu logo" className='w-48 mb-5 md:w-64'/></a>
//           <div className='flex flex-col justify-center md:items-center gap-7'>
//             <div className='flex flex-col sm:flex-row gap-9'>
//               {ecommerce === false ? (<ModalDemo />) : (<DemoEcommmerce/>) }
//               <a href="##"><span className='text-[1.1rem] text-[#333] sm:text-[1.3rem]'>Nosotros</span></a>
//               <a href="##"><span className='text-[1.1rem] text-[#333] sm:text-[1.3rem]'>Precios</span></a>
//             </div>
//             <div className='flex flex-col sm:flex-row gap-9'>
//             <a href="##"><span className='text-[1.1rem] text-[#333] sm:text-[1.3rem]'>Blog</span></a>
//               <a target="_blank" rel="nofollow noreferrer" href="https://policies.google.com/privacy"><span className='text-[1.1rem] text-[#333] sm:text-[1.3rem]'>Privacidad</span></a>
//               <a target="_blank" rel="nofollow noreferrer" href="https://policies.google.com/privacy"><span className='text-[1.1rem] text-[#333] sm:text-[1.3rem]'>Terminos y Condiciones</span></a>
//             </div>
//           </div>
//         </div>

//         <div className="flex justify-center items-center h-1/6 md:mt-8">
//           <span className='text-[.9rem]'>Karggu 2025. Todos los derechos reservados</span>
//         </div>
//       </div>
//     </>
//   )
// }

import whatsapp from '../svg/wa.svg';
import rojo from '../svg/rojo.svg';

export default function Footer() {
  return (
    <>
      <div>
        <a 
          href="https://api.whatsapp.com/send?phone=2211203777&text=Hola%20Karggu,%20me%20gustaría%20simplificar%20los%20procesos%20de%20carta%20porte,%20operación%20y%20profesionalizar%20mi%20empresa%20de%20transporte."
          target='_blank'
          rel='noreferrer noopener'
        >
          <img src={whatsapp} alt="whatsapp" className='w-14 md:w-16 h-14 md:h-216 fixed bottom-5 right-5'/>
        </a>
      </div>
      <div className="bg-[#000000] text-white flex flex-col justify-between">
        
        {/* Sección de CTA */}
        {/* <div className="flex flex-col items-center justify-center flex-grow text-center px-4">
          <h1 className="text-2xl md:text-4xl font-bold mb-10">Comienza a ahorrar, conoce Karggu</h1>
          <p className="mb-10 text-sm md:text-base">Compártenos tus datos y te contactaremos.</p>
          
          <form className="flex flex-col gap-4 w-full max-w-sm">
            <input
              type="text"
              placeholder="Nombre completo"
              className="rounded-full px-5 py-3 text-black outline-none"
            />
            <input
              type="email"
              placeholder="Correo electrónico"
              className="rounded-full px-5 py-3 text-black outline-none"
            />
            <input
              type="tel"
              placeholder="Teléfono"
              className="rounded-full px-5 py-3 text-black outline-none"
            />
            <input
              type="text"
              placeholder="Empresa"
              className="rounded-full px-5 py-3 text-black outline-none"
            />
          </form>
        </div> */}

        {/* Línea divisoria */}
        {/* <div className="border-t border-[#4c4c4cb8] my-5 mx-20"></div> */}

        {/* Pie de página */}
        <div className="flex flex-col md:flex-row justify-between items-center px-32 py-10 text-xs md:text-sm gap-6 md:gap-0">
          <div className="text-center md:text-left flex flex-col items-center md:items-start">
            <img src={rojo} alt="logo karggu" className='w-24 md:w-28 mb-2' />
            <p>KARGGU TECH SA DE CV</p>
            <p>admin@karggu.com</p>
          </div>

          <div className="text-center">
            <a href="/" className="block mb-1">Nosotros</a>
            <a href="/" className="block mb-1">Contacto</a>
            <a href="/" className="block mb-1">Blog</a>
            <a href="/" className="block mb-1">Aviso de Privacidad</a>
            <a href="/" className="block">Términos y Condiciones</a>
          </div>

          <div className="text-center md:text-right flex flex-col items-center md:items-end">
            <p>KARGGU TECH SA DE CV</p>
            <p>admin@karggu.com</p>
          </div>
        </div>
      </div>
    </>
  );
}
